<template>
    <div class="flats-crm-page" v-if="flatsPage != null">
        <flatsFilterMobile v-if="projectItems != null && isMobile"></flatsFilterMobile>
        <div class="container" :class="{'container-mobile': isMobile}">
            <div class="section-title section-title-mobile" v-if="isMobile">
                <h1>{{flatsPage.page_title}}</h1>
            </div>
            <flatsFilter v-if="projectItems != null && !isMobile"></flatsFilter>
            <flatsTopBar v-if="isMobile" id="flatsTopBar"></flatsTopBar>
            <transition name="fade" mode="out-in">
		        <flatsItemsGrid v-if="gridView"></flatsItemsGrid>
                <flatsItemsList v-else :mobileView="isMobile"></flatsItemsList>
            </transition>
            <!-- && flatsItems.length >= 30 && !hidePaginBtn -->
            <div class="pagination-btns" v-if="flatsItems != null && flatsPagintaion.remainingApartments != null && flatsPagintaion.remainingApartments != 0">
                <a href="#" @click.prevent="getMoreFlats">
                    <span>{{ flatsPage.flats_cards_info.flat_btn_pagin_load_more }} {{flatsPagintaion.remainingApartments}}</span>
                    
                </a>
            </div>
        </div>
        <formPage class="form-flat-card-crm" v-if="projectItems != null"></formPage>
        <flatsViewedSection class="viewed-section-flats-page"></flatsViewedSection>
        <!-- <div class="container container-share">
            <sharePostBottom class="flat-page-social-bottom" :options="[{title: 'Поделиться данной страницей:', data_title: 'Поиск квартир по любым параметрам с удобным фильтром, а так же возможность онлайн покупки недвижимости, выбери свою квартиру от BAZIS-A', data_link: 'https://sales.bazis.kz/flats/', data_page: 'flats', data_page_key: 'flats_page'}]"></sharePostBottom>
        </div> -->
    </div>
</template>

<script>

    import flatsFilter from '@/components/flats-crm/flats-crm-filter.vue'
    import flatsItemsGrid from '@/components/flats-crm/flats-crm-items.vue'
	import flatsItemsList from '@/components/flats-crm/flats-crm-items-list.vue'

	import flatsTopBar from '@/components/flats-crm/flats-crm-topbar-mobile.vue'
	import flatsFilterMobile from '@/components/flats-crm/flats-crm-filter-mobile.vue'
	import formPage from '@/components/forms/form-page.vue';	
    import flatsViewedSection from '@/components/flats-crm/flats-crm-viewed-flats.vue'
    // import sharePostBottom from '@/components/share/share-social-bottom.vue'
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    export default {
        name: 'flats-crm-page',
        components: {
            flatsFilter,
            flatsTopBar,
            flatsFilterMobile,
            flatsItemsGrid,
            flatsItemsList,
            flatsViewedSection,
            formPage,
            // sharePostBottom,
        },
        data () {
            return {
                title: 'Квартиры',
                isMobile: false,
                inViewCheck: false,
                slicky: false,
                topOffsetBar: 0,
                minusNum: 60,
            }
        },
        computed: mapGetters({
            flatsPage: 'loadFlatsPage',
            projectItems: 'loadProjectItemsDefault',
            flatsItems: 'loadFlatsItems',
            flatsPagintaion: 'loadFlatsPagination',
            filterDataBase: 'loadFilterData',
            paginPageNumber: 'loadPaginPageNumber',
            hidePaginBtn: 'loadHidePaginBtn',
			gridView: 'loadLandFlatsGridView',
        }),
        methods: {
            getMoreFlats() {
                // console.log(this.filterDataBase, ' TEST PAGIN DATA')
                const count = this.paginPageNumber + 1;
                this.$store.commit('UpdatePaginPageNumber', count);
                this.filterDataBase.pageNumber = this.paginPageNumber;
                this.$store.dispatch('getFlatsByPagination', this.filterDataBase);
                this.$store.dispatch('getFlatsPagintationCounters', this.filterDataBase);
                // console.log(this.paginPageNumber, 'COUNTS')
                // console.log(this.paginPageNumber, this.filterDataBase, count, 'UPDATE FILTER BY PAGIN MOVING')
            },
            slickyTopBar() {
                if (this.isMobile == true) {
                    // console.log(window.scrollY);
                    // console.log(this.topOffsetBar, this.banerTopCoockieVisible, this.minusNum)
                    if (this.banerTopCoockieVisible == true) {
                        this.minusNum = 120;
                    } else {
                        this.minusNum = 60;
                    }
                    if (window.scrollY >= this.topOffsetBar - this.minusNum) {
                        this.slicky = true;
                        // console.log(this.topOffetBar, 'asdasdasdasdasd')
                    } else {
                        this.slicky = false;
                    }
                }
            },
            isMobileCheck() {
                if (window.innerWidth < 767) {
                    this.isMobile = true
                }
            },
            handleResize() {
                if (window.innerWidth < 767) {
                    this.isMobile = true
                } else {
                    this.isMobile = false
                }
            },
            
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
            getParamsForTopBarMobile() {
                setTimeout(() => {
                    if (this.isMobile == true) {
                        this.topOffsetBar = parseInt($('#flatsTopBar').offset().top);
                        this.slickyTopBar();
                    } 
                }, 1000);
            }
        },
        beforeRouteEnter (to, from, next) {
            // if (store.state.projectItems == null) {
            //     store.dispatch('getProjectsItems');
            // }
            // if (store.state.flatsItems == null) {
            //     store.dispatch('getFlatsItems');
            // }
            if (store.state.projectItems != null) {
                next(vm => {
                    vm.$store.commit('removePageLoaderImg');
                    vm.isMobileCheck();
                    vm.checkResize();
                    vm.getParamsForTopBarMobile();
                    // vm.$parent.$refs.topProgress.done();
                    setTimeout(() => {
                        vm.$parent.$refs.topProgress.done();
                    }, 100);
                });
            } else {
                store.dispatch('getProjectsItems').then((response) => {
                    // console.log(response, 'how to by')
                    if (response) {
                        next(vm => {
                            vm.$store.commit('removePageLoaderImg');
                            vm.isMobileCheck();
                            vm.checkResize();
                            vm.getParamsForTopBarMobile();
                            // vm.$parent.$refs.topProgress.done();
                            setTimeout(() => {
                                vm.$parent.$refs.topProgress.done();
                            }, 100);
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            document.body.dataset.page = 'flats';
        },
        created () {
            window.addEventListener('scroll', this.slickyTopBar);
        },
        destroyed() {
            window.removeEventListener('scroll', this.slickyTopBar);
            // this.$parent.$refs.topProgress.done();
        },
        mounted() {
        },
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-page.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-page-respond.scss';
</style>